import React from 'react'
import styled from 'styled-components'
import { setLocale } from '@localization/i18n'
import { useLanguage } from '@state/uses/app'
import { setLanguage } from '@state/actions/app'
import { useDispatch } from 'react-redux'

export default ({ show, setLangDropdownVisible }) => {
    const language = useLanguage()
    const dispatch = useDispatch()
    const padFrom = language === 'he' ? 'left' : 'right'

    return (
        <DropDown
            style={{
                visibility: show ? 'visible' : 'hidden',
                [padFrom]: '12px',
            }}>
            <DropDownItem
                onClick={() => {
                    dispatch(setLanguage('he'))
                    setLocale('he')
                    setLangDropdownVisible(false)
                }}>
                עברית
            </DropDownItem>
            <DropDownItem
                onClick={() => {
                    dispatch(setLanguage('en'))
                    setLocale('en')
                    setLangDropdownVisible(false)
                }}>
                English
            </DropDownItem>
        </DropDown>
    )
}

const DropDown = styled.div`
    top: 52px;
    z-index: 1;
    height: auto;
    outline: none;
    min-width: 80px;
    padding: 4px 8px;
    position: absolute;
    background-color: #ffffff;
    border: 1px solid rgb(83, 71, 103);
    border-top: none;

    @media (max-width: 768px) {
        top: 50px;
    }
`

const DropDownItem = styled.div`
    text-align: right;
    padding: 4px 0px;
    color: rgb(83, 71, 103);
`
